import type { TimelineIndex, TimelineNode } from './dag.js';

export interface SearchQuery {
  /** Substring match against entry kind. */
  kind?: string;
  /** Substring match against the tool name (payload.name on tool_call). */
  tool?: string;
  /** Free-text match against a JSON-ified payload. Case-insensitive. */
  text?: string;
  /** Only entries whose offsetMs is within [from, to] (inclusive). */
  from?: number;
  to?: number;
}

export function searchTimeline(index: TimelineIndex, query: SearchQuery): TimelineNode[] {
  const kindNeedle = query.kind?.toLowerCase();
  const toolNeedle = query.tool?.toLowerCase();
  const textNeedle = query.text?.toLowerCase();
  return index.nodes.filter((node) => {
    if (kindNeedle && !node.entry.kind.toLowerCase().includes(kindNeedle)) return false;
    if (toolNeedle) {
      const name = String((node.entry.payload as { name?: unknown }).name ?? '').toLowerCase();
      if (!name.includes(toolNeedle)) return false;
    }
    if (textNeedle) {
      const blob = JSON.stringify(node.entry.payload).toLowerCase();
      if (!blob.includes(textNeedle)) return false;
    }
    if (query.from !== undefined && node.offsetMs < query.from) return false;
    if (query.to !== undefined && node.offsetMs > query.to) return false;
    return true;
  });
}
